<script setup>
import { RouterView } from 'vue-router'
</script>

<template>
  <div style="width: 100vw;height: 100vh;">
    <RouterView />
  </div>
</template>

<style scoped></style>
